import { gql } from '@apollo/client'

export const SEND_LOGIN_CODE = gql`
  mutation sendLoginCode($input: SendLoginCodeInput!) {
    sendLoginCode(input: $input) {
      errors {
        code
        message
      }
      warnings {
        code
        message
      }
    }
  }
`
